{
  "version": 1,
  "asset_id": "87029f95-cac8-41f5-af34-8300f5071ccf",
  "project_id": "ab945133-766b-45c0-8595-d741bb5019f6",
  "url": "/__l5e/assets-v1/87029f95-cac8-41f5-af34-8300f5071ccf/corden-pharma-logo.svg",
  "r2_key": "a/v1/ab945133-766b-45c0-8595-d741bb5019f6/87029f95-cac8-41f5-af34-8300f5071ccf/corden-pharma-logo.svg",
  "original_filename": "corden-pharma-logo.svg",
  "size": 4093,
  "content_type": "image/svg+xml",
  "created_at": "2026-08-18T15:37:08Z"
}
